//@flow
import React from 'react';

import type MembershipPlanModel from '../../Stores/Membership/membershipPlanModel';

import snackGuarantee from '../../../images/membership/snack-guarantee.png';
import freeTrial from '../../../images/membership/free-trial.png';
import memGuarantee from '../../../images/membership/mem-guarantee-award.png';
import unlimitedDiscount from '../../../images/membership/unlimited-discount.png';
import freeShipping from '../../../images/membership/free-shipping.png';

const firstTitle = 'Membership Guarantee';
const firstDesc = `If you don't make your membership fee back in savings during your first year, let us know and we'll pay you the difference! Try it for free for 15 days, then it's just $36/year.`;

type Props = {
  children:React$Node,
  membershipPlan:MembershipPlanModel,
};

const _renderBenefit = (title:string, text:string, className:string, image:any, alt:string) => {
  return (
    <div className="membership-perk columns small-12 medium-6">
      <div className={`mem-perk-img-container ${className}`}>
        <img className={`icon`} src={image} alt={alt} />
      </div>
      <div className="text-2 bold">{title}</div>
      <div className="text-3">{text}</div>
    </div>
  );
};

export default function AboutMembershipContent(props:Props) {
  return (
    <div>
      <h2 className="perks-header">Membership Subscription Benefits</h2>
      <div className="member-benefit-first">
        <div className="left">
          <img alt="medal" src={memGuarantee} className="medal" />
        </div>
        <div className="right">
          <div className="first-title text-2 bold">
            {firstTitle}
          </div>
          <div className="first-content text-3">
            {firstDesc}
          </div>
        </div>
      </div>
      <div className="member-benefit-list">
        <div className="benefit-row">
          {_renderBenefit("Free Shipping", `Get free shipping in the continental US on orders of $40 or more after discounts and membership savings.`, "free-shipping", freeShipping, "shipping")}
          {_renderBenefit("Monthly Credit", `Earn $6 in store credit each month - that's $72 per year - double the membership cost! (Credits expire each month)`, "monthly-credit", freeTrial, "trial")}
        </div>
        <div className="benefit-row">
          {_renderBenefit("Unlimited Discount", "Save 20%-30% on most items, every day.", "mem-discount", unlimitedDiscount, "discount")}
          {_renderBenefit("Snack Guarantee", "If you don't love a snack, we'll replace it!", "", snackGuarantee, "guarantee")}
        </div>
      </div>
      {props.children}
    </div>
  );
}
